<script>
	import Select, { Option } from "@smui/select";

	import { organizations, selectedOrganization, selectedOrganizationObj, setupComplete } from "../stores";
</script>

{#if $setupComplete}
	<div class="main-select organization-selection">
		<Select
			bind:value={$selectedOrganization}
			variant="outlined"
			label="Organization"
			disabled={$organizations.length <= 1}
		>
			{#each $organizations as o}
				<Option value={o.organisation_id}>{o.name}</Option>
			{/each}
		</Select>
	</div>
{/if}

<style lang="scss">
	.organization-selection {
		:global(.mdc-select--disabled .mdc-select__dropdown-icon) {
			transition: opacity 0.3s ease;
			opacity: 0;
		}
	}
</style>
